export type { TooltipProps } from "@components/contracts/Tooltip.types";
export { CelebrationTooltip } from "./Tooltip.adapter";
